import React, { Component } from 'react';
import { SearchBox } from '../../../UiKit';
import './AddManualTag.scss';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';
import {
  ORDER_EVENTS,
  sendManualTagEvents,
} from '../../../helpers/analytics/order.analytics';

export default class AddManualTag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddBtn: true,
      selectedTag: null,
    };
  }

  addManulTag = () => {
    const { orderId, userId } = this.props;
    sendManualTagEvents(
      ORDER_EVENTS.MANUAL_TAG_SEARCH_BOX_OPEN,
      orderId,
      userId,
    );
    this.setState({
      showAddBtn: false,
    });
  };

  onSelectTag = (selectedValue) => {
    const { onSelectTag, manualTags } = this.props;
    const { url } = manualTags;
    this.setState({
      selectedTag: selectedValue,
      showAddBtn: true,
    });
    onSelectTag(selectedValue, url);
  };

  closeSearchBox = () => {
    const { orderId, userId } = this.props;
    sendManualTagEvents(
      ORDER_EVENTS.MANUAL_TAG_SEARCH_BOX_CLOSE,
      orderId,
      userId,
    );
    this.setState({
      showAddBtn: true,
    });
  };

  render() {
    const { manualTags, addedTags } = this.props;
    const { showAddBtn } = this.state;
    if (!manualTags) return null;
    const { manual_tags_list } = manualTags;

    return (
      <div className='manualTags'>
        {showAddBtn ? (
          <div
            className='tag colorGreen tw-text-[1.4rem]'
            onClick={this.addManulTag}
          >
            + Add Tag
          </div>
        ) : (
          <OnClickOutside handleClickOutside={this.closeSearchBox}>
            <div className='manualTagSearchBox'>
              <SearchBox
                result={manual_tags_list}
                addedTags={addedTags}
                padding='0.3rem 1rem'
                onSelect={this.onSelectTag}
              />
            </div>
          </OnClickOutside>
        )}
      </div>
    );
  }
}
